<template>
  <b-modal
    id="new-email-modal"
    ref="new-email-modal"
    @show="resetForm"
    @hidden="visible = false"
    @ok="handleOk"
    body-class="nice-modal"
    :visible="visible"
    :ok-title="$t('button.ok')"
    :cancel-title="$t('button.cancel')"
  >
    <template v-slot:modal-header>
      <div>
        <h5 v-if="isNew">{{ $t("newemail.h_set") }}</h5>
        <h5 v-else>{{ $t("newemail.h_change") }}</h5>
        <p v-if="!isNew">
          {{ $t("newemail.d_change", { email: current }) }}
        </p>
      </div>
    </template>

    <b-overlay :show="loading" variant="white" opacity="0.7">
      <template v-if="verification">
        <p>{{ $t("verification.text") }}</p>
        <verification-code
          v-on:verifed="onVerifed"
          :email="newEmail"
        ></verification-code>
      </template>
      <template v-else>
        <form ref="form" @submit.stop.prevent="handleSubmit" autocomplete="off">
          <!-- Email #1 ----------------------------------------------------------->
          <b-form-group
            id="input-group-1"
            :label="$t('newemail.form.email.label')"
            :label-for="rndId1"
            label-cols-sm="4"
          >
            <b-form-input
              :id="rndId1"
              :disabled="loading"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              autocomplete="off"
            ></b-form-input>
            <b-form-invalid-feedback>{{
              $t("form.validEmail")
            }}</b-form-invalid-feedback>
          </b-form-group>

          <!-- Email #2 ----------------------------------------------------------->
          <b-form-group
            id="input-group-2"
            :label="$t('newemail.form.email2.label')"
            :label-for="rndId2"
            label-cols-sm="4"
            class="mb-4"
          >
            <b-form-input
              :id="rndId2"
              :disabled="loading"
              v-model="$v.form.email2.$model"
              type="email"
              :state="validateState('email2')"
              autocomplete="nope"
            ></b-form-input>
            <b-form-invalid-feedback>{{
              $t("form.emailDiff")
            }}</b-form-invalid-feedback>
          </b-form-group>

          <!-- Password ----------------------------------------------------------->
          <b-form-group
            id="input-group-3"
            :label="$t('newemail.form.pass.label')"
            :label-for="rndId3"
            label-cols-sm="4"
          >
            <b-form-input
              :id="rndId3"
              :disabled="loading"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
              type="password"
              autocomplete="new-password"
            ></b-form-input>
            <b-form-invalid-feedback>{{
              $t("form.required")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </form>
      </template>
    </b-overlay>
  </b-modal>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email, sameAs } from "vuelidate/lib/validators";
import makeid from "@/util/rnd";
import VerificationCode from "@/components/VerificationCode";
import { SET_EMAILS } from "@/store/consts";
import { LONG_DESIGN_DELAY, URL_SET_USER_EMAIL } from "@/globals";

export default {
  components: { VerificationCode },
  name: "NewEmailModal",
  mixins: [validationMixin],
  props: {
    current: {
      type: String,
      required: "",
    },
  },
  data() {
    return {
      form: {
        email: "",
        email2: "",
        password: "",
      },
      loading: false,
      verification: false,
      rndId1: null,
      rndId2: null,
      rndId3: null,
      visible: false,
      newEmail: null,
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      email2: {
        required,
        sameAsMmail: sameAs("email"),
      },
      password: {
        required,
      },
    },
  },
  computed: {
    isNew() {
      return !this.$store.state.user.emails.length;
    },
  },
  methods: {
    show() {
      this.visible = true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.verification = false;
      this.form.email = "";
      this.form.email2 = "";
      this.password = "";
      this.$v.$reset();
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.$patch(
        URL_SET_USER_EMAIL,
        {
          email: this.form.email,
          password: this.form.password,
        },
        true,
        true,
        LONG_DESIGN_DELAY
      )
        .then((result) => {
          this.$store.commit(SET_EMAILS, result.emails);
          this.newEmail = result.emails.find((e) => e.id === result.id);
          this.verification = true;
          this.rndId1 = makeid(10);
        })
        .catch((e) => {
          this.$alert.show(e);
        });
    },
    onVerifed(state) {
      if (state) {
        this.$refs["new-email-modal"].hide();
      }
    },
  },
  created() {
    this.rndId1 = makeid(10);
    this.rndId2 = makeid(10);
    this.rndId3 = makeid(10);
  },
};
</script>

<style>
.modal-header p {
  margin: 0;
}
</style>